import Vue from 'vue';
import {Task as TaskModel} from '@/interfaces/TaskInterfaces';
import TaskColumnMixin from '@/mixins/TaskColumnMixin';

export default Vue.component('task-column', {
  name: 'TaskColumn',
  props: {
    header: { type: String },
    shouldDisplayReadStatus: {
      type: Boolean,
      default: true
    }
  },
  mixins: [TaskColumnMixin],
  methods: {
    async toggleEdit(task: TaskModel) {
      task.isEditing = !task.isEditing;
      // Hack to get it to go
      (this as any).ourTasks = (this as any).ourTasks.map((task: any) => task);
      if (!task.isRead && task.assignedToAppUserId === this.$store.state.user.appUserId) {
        await (this as any).markRead(task);
      }
      (this as any).storeEditingTaskState(task);
    }
  }
});



// WEBPACK FOOTER //
// ./src/componentsReusable/tasks/column/TaskColumn.ts